'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RatingItems;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _star = require('./star');

var _star2 = _interopRequireDefault(_star);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function RatingItems(props) {
  var onChange = props.onChange,
      value = props.value,
      name = props.name;
  return Array(5).fill(0).map(function (item, index) {
    var key = 'star-' + index;
    var filled = index < value;
    return _react2.default.createElement(_star2.default, {
      key: key,
      name: name,
      onChange: onChange,
      value: index + 1,
      filled: filled
    });
  });
}

RatingItems.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  name: _propTypes2.default.string
};
RatingItems.defaultProps = {
  value: undefined,
  onChange: function onChange() {},
  name: undefined
};